import { render, staticRenderFns } from "./RouteMapWithPointsBlock.vue?vue&type=template&id=6edd502e&"
import script from "./RouteMapWithPointsBlock.vue?vue&type=script&lang=js&"
export * from "./RouteMapWithPointsBlock.vue?vue&type=script&lang=js&"
import style0 from "./RouteMapWithPointsBlock.vue?vue&type=style&index=0&id=6edd502e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports